import { useMemo } from 'react';
import { useAppContext } from '../../shared/AppContext';
import { auditEntriesStore } from '../../../api/v2/AuditApi';

export const useAuditLogController = () => {
    const app = useAppContext();

    // One store for the life of the page. Handing the grid a new one restarts its load, and the
    // grid owns the filter and sort state now that both are applied server-side.
    const store = useMemo(() => auditEntriesStore(), []);

    return {
        isSuper: app.UserIsSuper,
        store,
    };
};

export type AuditLogControllerProps = ReturnType<typeof useAuditLogController>;
